import { CubicBezierTimingFunction, StandardPropertiesHyphen } from 'csstype';

type Transitionable = keyof StandardPropertiesHyphen;
export const mkTransitions = (
  duration: string,
  timingFn: CubicBezierTimingFunction = '',
  ...props: Transitionable[]
) => props.map(prop => `${prop} ${duration} ${timingFn}`).join(',');
